import InfiniteScroll from 'react-infinite-scroll-component'
import { useDispatch, useSelector } from 'react-redux'
import { Movement } from 'src/features/types'
import { NumberFmt } from 'src/utils'
import { formatDate } from 'src/utils/formatDate'
import { mapMovementType } from 'src/utils/mappers/mapMovementType'
import Table from 'src/features/base/components/Table'
import { ScrollMessage } from 'src/features/base/components/Table/Table.styles'
import { selectHasNextPage, selectMovements } from '../../StockMovementsSeletor'
import { actions } from '../../StockMovementsState'
import columns from './MovementsTable.columns'

export default () => {
  const dispatch = useDispatch()
  const hasNext = useSelector(selectHasNextPage)
  const movements = useSelector(selectMovements)

  const prepareMovements = (data: Movement[]) => data.map((m) => (
    {
      ...m,
      createdAt: formatDate(m.createdAt),
      type: mapMovementType(m.type),
      appliedQuantity: NumberFmt({ value: m.appliedQuantity, sufix: '' }),
      balance: NumberFmt({ value: m.balance, sufix: '' }),
    }))

  const handleNextPage = () => {
    dispatch(actions.nextPage())
    dispatch(actions.getMovements())
  }

  return (
    <InfiniteScroll
      dataLength={movements.length}
      next={handleNextPage}
      hasMore={hasNext}
      loader={<ScrollMessage>Carregando mais dados</ScrollMessage>}
      endMessage={<ScrollMessage>Fim dos resultados</ScrollMessage>}
      style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}
    >
      <Table
        data={prepareMovements(movements)}
        columns={columns}
      />
    </InfiniteScroll>
  )
}
